module.exports = __webpack_public_path__ + "static/media/solution17.c0d83aa7.jpg";